// Default landing page (.tp-default) — guarded so it only runs on page-default.php.
// FAQ accordion + smooth in-page anchors. (Hover styling is pure CSS now.)
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-default');
    if (!root) {
        return;
    }

    // ── Mobile burger menu (toggles body.menu-open, like header-home) ──
    var burger = root.querySelector('.tp-nav__burger');
    if (burger) {
        burger.addEventListener('click', function () {
            document.body.classList.toggle('menu-open');
        });
    }

    // ── Mobile menu: tap the dropdown parent to open/close its submenu ──
    root.querySelectorAll('.tp-mobile__menu .tp-menu__parent').forEach(function (parent) {
        parent.addEventListener('click', function () {
            var li = parent.closest('.menu-item-has-children');
            if (li) {
                li.classList.toggle('is-open');
            }
        });
    });

    // ── FAQ accordion (single-open: opening one closes the others) ──
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.tp-faq-item'));

    function setFaq(item, open) {
        var panel = item.querySelector('.tp-faq-panel');
        var sign = item.querySelector('.tp-faq-sign');
        item.classList.toggle('is-open', open);
        var q = item.querySelector('button');
        if (q) { q.setAttribute('aria-expanded', open ? 'true' : 'false'); }
        if (panel) {
            panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        }
        if (sign) {
            sign.textContent = open ? '–' : '+';
        }
    }

    faqItems.forEach(function (item) {
        var btn = item.querySelector('.tp-faq-q');
        if (!btn) {
            return;
        }
        if (item.classList.contains('is-open')) {
            setFaq(item, true);
        }
        btn.addEventListener('click', function () {
            var willOpen = !item.classList.contains('is-open');
            faqItems.forEach(function (other) {
                if (other !== item) {
                    setFaq(other, false);
                }
            });
            setFaq(item, willOpen);
        });
    });

    // ── Price-card accordion (single-open within each card, independent of the FAQ) ──
    root.querySelectorAll('.tp-price-acc').forEach(function (acc) {
        var items = Array.prototype.slice.call(acc.querySelectorAll('.tp-price-acc__item'));

        function setItem(item, open) {
            var panel = item.querySelector('.tp-price-acc__panel');
            var sign = item.querySelector('.tp-price-acc__sign');
            var btn = item.querySelector('.tp-price-acc__q');
            item.classList.toggle('is-open', open);
            if (panel) {
                panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
            }
            if (sign) {
                sign.textContent = open ? '–' : '+';
            }
            if (btn) {
                btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            }
        }

        items.forEach(function (item) {
            var btn = item.querySelector('.tp-price-acc__q');
            if (!btn) {
                return;
            }
            if (item.classList.contains('is-open')) {
                setItem(item, true);
            }
            btn.addEventListener('click', function () {
                var willOpen = !item.classList.contains('is-open');
                items.forEach(function (other) {
                    if (other !== item) {
                        setItem(other, false);
                    }
                });
                setItem(item, willOpen);
            });
        });
    });

    // ── "Realistic Fitness" mini cards — accordion on mobile only ──
    (function () {
        var minis = Array.prototype.slice.call(root.querySelectorAll('.tp-mini'));
        if (!minis.length) {
            return;
        }

        var mq = window.matchMedia('(max-width: 767.98px)');

        function reset() {
            minis.forEach(function (card) {
                var answer = card.querySelector('p:last-child');
                card.classList.remove('is-open');
                if (answer) {
                    answer.style.maxHeight = '';
                }
            });
        }

        minis.forEach(function (card) {
            var q = card.querySelector('p:first-child');
            var answer = card.querySelector('p:last-child');
            if (!q || !answer || q === answer) {
                return;
            }
            q.addEventListener('click', function () {
                if (!mq.matches) {
                    return;
                }
                var willOpen = !card.classList.contains('is-open');
                minis.forEach(function (other) {
                    if (other !== card) {
                        other.classList.remove('is-open');
                        var oa = other.querySelector('p:last-child');
                        if (oa) {
                            oa.style.maxHeight = '0';
                        }
                    }
                });
                card.classList.toggle('is-open', willOpen);
                // is-open is already applied, so scrollHeight includes the open padding.
                answer.style.maxHeight = willOpen ? answer.scrollHeight + 'px' : '0';
            });
        });

        if (mq.addEventListener) {
            mq.addEventListener('change', reset);
        } else if (mq.addListener) {
            mq.addListener(reset);
        }
    })();

    // ── Smooth scroll for in-page anchors ──
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var hash = link.getAttribute('href');
            if (hash.length < 2) {
                return;
            }
            var target = document.querySelector(hash);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            document.body.classList.remove('menu-open'); // close the mobile menu
        });
    });
});
